import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-77d83750"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-text-left" }
const _hoisted_2 = { class: "p-mb-4 p-mx-2" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-my-1 p-mt-2 p-mb-2 p-text-bold" }, "รายการสินค้า", -1))
const _hoisted_4 = { class: "p-p-3 shadow bg-color-secondary rounded p-d-flex p-my-2" }
const _hoisted_5 = {
  key: 0,
  class: "p-my-auto"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "p-ml-2 w-100" }
const _hoisted_8 = { class: "p-d-flex w-100" }
const _hoisted_9 = { class: "line-clamp" }
const _hoisted_10 = { class: "p-ml-auto" }
const _hoisted_11 = { class: "f-size-14 text-gray-1" }
const _hoisted_12 = { class: "p-d-flex" }
const _hoisted_13 = { class: "f-size-14 text-gray-1" }
const _hoisted_14 = {
  key: 0,
  class: "p-ml-auto f-size-14"
}
const _hoisted_15 = { class: "text-gray-1" }
const _hoisted_16 = { class: "p-ml-2 text-dark" }
const _hoisted_17 = {
  key: 1,
  class: "p-ml-auto f-size-14 text-gray-1"
}
const _hoisted_18 = {
  key: 0,
  class: "p-mt-2 f-size-12 text-gray-1"
}
const _hoisted_19 = { class: "p-mt-4" }
const _hoisted_20 = { class: "p-d-flex" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "ค่าจัดส่ง", -1))
const _hoisted_22 = { class: "p-ml-auto" }
const _hoisted_23 = { class: "p-d-flex" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "ราคารวม", -1))
const _hoisted_25 = { class: "p-ml-auto" }
const _hoisted_26 = {
  key: 0,
  class: "p-d-flex"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "ส่วนลด", -1))
const _hoisted_28 = { class: "p-ml-auto" }
const _hoisted_29 = { class: "p-d-flex" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "ส่วนลดค่าจัดส่ง", -1))
const _hoisted_31 = { class: "p-ml-auto" }
const _hoisted_32 = { class: "p-d-flex" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "ราคาสุทธิ", -1))
const _hoisted_34 = { class: "p-ml-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TransactionPromotion = _resolveComponent("TransactionPromotion")!
  const _component_TransactionFreeProduct = _resolveComponent("TransactionFreeProduct")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Panel, {
        header: 
          'รายการสั่งซื้อ (ราคาสุทธิ ' +
          _ctx.$filters.formatNumber(_ctx.transaction.grandTotal) +
          ' )'
        ,
        toggleable: true,
        collapsed: _ctx.isCollapsed,
        "onUpdate:collapsed": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isCollapsed) = $event))
      }, {
        icons: _withCtx(() => [
          _createElementVNode("span", {
            class: "text-gray-1 f-size-14",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isCollapsed = !_ctx.isCollapsed))
          }, "ดูรายละเอียด")
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transaction.products, (product, pindex) => {
              return (_openBlock(), _createElementBlock("div", {
                key: 'product_' + pindex
              }, [
                _createElementVNode("div", _hoisted_4, [
                  (product.imageUrl)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createElementVNode("img", {
                          src: product.imageUrl,
                          class: "product-image"
                        }, null, 8, _hoisted_6)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, _toDisplayString(product.name), 1),
                      _createElementVNode("div", _hoisted_10, _toDisplayString(product.quantity), 1)
                    ]),
                    _createElementVNode("div", _hoisted_11, _toDisplayString(product.barcode) + " ( " + _toDisplayString(product.sku) + " ) ", 1),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$filters.formatNumber(product.price)) + " x " + _toDisplayString(product.quantity), 1),
                      (product.discountStikePrice !== 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _createElementVNode("del", _hoisted_15, _toDisplayString(_ctx.$filters.formatNumber(product.total)), 1),
                            _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$filters.formatNumber(product.stikePrice)), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.$filters.formatNumber(product.total)), 1))
                    ]),
                    (product.discountStikePrice !== 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          _createVNode(_component_TransactionPromotion, {
                            displayPromotions: product.displayPromotions
                          }, null, 8, ["displayPromotions"])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            }), 128)),
            _createElementVNode("div", null, [
              _createVNode(_component_TransactionFreeProduct, {
                freeProducts: _ctx.transaction.freeProducts,
                isEdit: false,
                ref: "freeProductPanel"
              }, null, 8, ["freeProducts"])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$filters.formatNumber(_ctx.transaction.shippingCost)), 1)
              ]),
              _createElementVNode("div", _hoisted_23, [
                _hoisted_24,
                _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$filters.formatNumber(_ctx.transaction.total)), 1)
              ]),
              (_ctx.transaction.discount > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _hoisted_27,
                    _createElementVNode("div", _hoisted_28, " - " + _toDisplayString(_ctx.$filters.formatNumber(_ctx.transaction.discount)), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_29, [
                _hoisted_30,
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$filters.formatNumber(_ctx.transaction.discountShipping)), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_32, [
                _hoisted_33,
                _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.$filters.formatNumber(_ctx.transaction.grandTotal)), 1)
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["header", "collapsed"])
    ])
  ]))
}